<template>
  <div class="scene-view-box">
    <Header
      :sceneInfo="sceneInfo"
      :activeToolBar="activeToolBar"
      :openElemSearchDialog="openElemSearchDialog"
      :openViewPortPanel="openViewPortPanel"
      @openAnnotationPanel="openAnnotationPanel"
      @openAnchorPanel="openAnchorPanel"
      :openRoaming="openRoaming"
      v-if="showEngHeader" />
    <ViewTreePanel
      v-show="viewTreePanelVisible"
      ref="viewTreePanel"
      :sceneData="originSceneData"
      :openTexturePanel="openTexturePanel"
      :closePanel="closeViewTreePanel"
      :focusDataSets="focusDataSets"
      :focusElems="focusElems"
      :showDataSets="showDataSets"
      :hideDataSets="hideDataSets"
      :showElement="showElement"
      :hiddenElement="hiddenElement"
      :highLightWaters="highLightWaters"
      :showWaters="showWaters"
      :hideWaters="hideWaters"
      :highLightExtrudes="highLightExtrudes"
      :showExtrudes="showExtrudes"
      :hideExtrudes="hideExtrudes" />
    <TexturePanel
      v-if="texturePanelVisible"
      ref="texturePanel"
      :dataSet="currSelectDataSet"
      :closePanel="closeTexturePanel" />
    <ParamsPanel
      v-if="isParamsPanelVisible"
      ref="paramsPanel"
      :elemInfo="currElemInfo"
      :openAddextendParamsDialog="openAddextendParamsDialog"
      :closeParamsPanel="closeParamsPanel" />
    <AddExtendParamsDialog
      :visible="isAddExtendParamsDialogVisible"
      :elemInfo="currElemInfo"
      :closeDialog="closeAddextendParamsDialog" />
    <ElemSearchDialog
      ref="elemSearchDialog"
      :sceneData="originSceneData"
      :visible="isElemSearchDialogVisible" />

    <RoamingDialog
      ref="roamingDialog"
      :visible="RoamingVisible"
      :closeDialog="closeRoamingVisible" />
    <ViewportPanel
      v-if="isViewportPanelVisible"
      ref="viewportPanel"
      :openAddViewportDialog="openAddViewportDialog"
      :closeViewportPanel="closeViewportPanel" />
    <AddViewportDialog
      :visible="isAddViewportDialogVisible"
      :viewportInfo="viewportInfo"
      :refreshViewportList="refreshViewportList"
      :closeDialog="closeAddViewportDialog" />
    <AnnotationPanel
      v-show="isAnnotationPanelVisible"
      ref="annotationPanel"
      @closeAnnotationPanel="closeAnnotationPanel"
      @openAnnotationToolBar="openAnnotationToolBar"
      @openAnnotationDialog="openAddAnnotationDialog"
      @openAnnotationViewport="openAnnotationViewport" />
    <AddAnnotationDialog
      :visible="isAddAnnotationDialogVisible"
      ref="addAnnotationDialog"
      :annotationInfo="annotationInfo"
      :refreshAnnotationList="refreshAnnotationList"
      @addViewport="addViewport"
      @modifyViewport="modifyViewport"
      @openAnnotatioTypeDialog="openAnnotatioTypeDialog"
      @closeAnnotationToolBar="closeAnnotationToolBar"
      @closeDialog="closeAddAnnotationDialog" />
    <AddAnnotationTypeDialog
      :visible="isAddAnnotatioTypeDialogVisible"
      @refreshAnnotationTypeList="refreshAnnotationTypeList"
      @closeAnchorTypeDialog="closeAnnotatioTypeDialog" />
    <AnchorPanel
      v-if="isAnchorPanelVisible"
      ref="anchorPanel"
      :enableAnchorPointShow="sceneInfo.enableAnchorPointShow"
      @UpdateSceneInfo="initSceneInfo"
      @closeAnchorPanel="closeAnchorPanel"
      @openAnchorDialog="openAnchorDialog"
      @openAnchorGroupDialog="openAnchorGroupDialog"
      @openDeleteGroupDialog="openDeleteGroupDialog" />
    <AddAnchorGroupDialog
      :visible="isAddAnchorGroupDialogVisible"
      :refreshAnchorGroupList="refreshAnchorGroupList"
      @closeAnchorGroupDialog="closeAnchorGroupDialog" />
    <AddAnchorTypeDialog
      :visible="isAddAnchorTypeDialogVisible"
      @refreshAnchorTypeList="refreshAnchorTypeList"
      @closeAnchorTypeDialog="closeAnchorTypeDialog" />
    <AddAnchorDialog
      v-if="isAddAnchorDialogVisible"
      ref="addAnchorDialog"
      :anchorInfo="anchorInfo"
      :refreshAnchorList="refreshAnchorList"
      @openAnchorGroupDialog="openAnchorGroupDialog"
      @openAnchorTypeDialog="openAnchorTypeDialog"
      @closeDialog="closeAddAnchorDialog" />
    <DeleteGroupDialog
      :visible="isDeleteGroupDialogVisible"
      :groupIdToDelete="groupIdToDelete"
      :refreshAnchorList="refreshAnchorList"
      @reRnderAnchor="reRnderAnchor"
      @closeDialog="closeDeleteGroupDialog" />
    <div class="engine-box">
      <Engine ref="engine" />
      <CanvasMouseTip />
      <AnnotationToolBar
        v-if="isAnnotationToolBarVisible"
        ref="annotationToolBar"
        @openAddAnnotationDialog="openAddAnnotationDialog"
        @closeAnnotationToolBar="closeAnnotationToolBar" />
      <AnnotationViewportImg
        v-if="isAnnotationViewportImgVisible"
        :viewportImg="viewportImg"
        @closeAnnotationViewport="closeAnnotationViewport" />
      <ExplodePanel
        v-if="isExplodePanelVisible"
        :sceneData="originSceneData"
        @setCurrentKey="setCurrentKey"
        @closeExplodePanel="closeExplodePanel" />
    </div>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import ViewTreePanel from './components/ViewTreePanel.vue'
import Engine from '../components/SceneViewEngine.vue'
import CanvasMouseTip from './components/EngineCanvasMouseTip.vue'
import TexturePanel from './components/TexturePanel.vue'
import ParamsPanel from './components/ParamsPanel.vue'
import AddExtendParamsDialog from './components/AddExtendParamsDialog.vue'
import ElemSearchDialog from './ElemSearch/ElemSearchDialog.vue'
import ViewportPanel from './viewport/ViewportPanel.vue'
import AddViewportDialog from './viewport/AddViewportDialog.vue'
import AnnotationPanel from './annotation/AnnotationPanel.vue'
import AnnotationToolBar from './annotation/annotationToolBar/AnnotationToolBar.vue'
import AddAnnotationDialog from './annotation/AddAnnotationDialog.vue'
import AddAnnotationTypeDialog from './annotation/AddAnnotationTypeDialog.vue'
import AnnotationViewportImg from './annotation/AnnotationViewportImg.vue'
import RoamingDialog from './Roaming/RoamingDialog.vue'
import AnchorPanel from './anchor/AnchorPanel.vue'
import AddAnchorDialog from './anchor/AddAnchorDialog.vue'
import AddAnchorGroupDialog from './anchor/AddAnchorGroupDialog.vue'
import AddAnchorTypeDialog from './anchor/AddAnchorTypeDialog.vue'
import DeleteGroupDialog from './anchor/DeleteGroupDialog.vue'
import ExplodePanel from './explode/ExplodePanel.vue'
import eventBus from '@/utils/eventBus'
import { Store } from '@/utils/store'

import { highLightElems } from '@/utils/engineUtils'

import { getTokenId } from '@/utils/generalMethods'

import {
  getClientTokenService,
  getSceneById,
  getSingleSceneTreeById,
  getDataSetResService,
  getViewAngleService,
  getTextureList,
  getExtrudeTexturesService,
  getRvtGroupByElemIdService,
  getBimElemIdsByGroupService,
  getSceneAnchorListService
} from '@/service/interface'

const elemDataSetType = [17, 18, 19]
// prettier-ignore
const animAnchorPicPath = "https://demo.bjblackhole.com/css/img/anc_anim - 副本.png";
// prettier-ignore
const mergePicPath = 'https://demo.bjblackhole.com/demopage/examplesImgs/bubbler.png';
export default {
  data() {
    return {
      sceneInfo: {},
      originSceneData: [],

      viewTreePanelVisible: false,

      texturePanelVisible: false,
      currSelectDataSet: {},

      currElemInfo: {},
      isParamsPanelVisible: false,
      isAddExtendParamsDialogVisible: false,

      activeToolBar: '',
      isElemSearchDialogVisible: false,

      viewportInfo: null,
      isViewportPanelVisible: false,
      isAddViewportDialogVisible: false,

      annotationInfo: {},
      isAnnotationPanelVisible: false,
      isAnnotationToolBarVisible: false,
      isAddAnnotationDialogVisible: false,
      isAnnotationViewportImgVisible: false,
      viewportImg: '',
      RoamingVisible: false,
      isAddAnnotatioTypeDialogVisible: false,

      isAnchorPanelVisible: false,
      anchorInfo: null,
      isAddAnchorDialogVisible: false,
      isAddAnchorGroupDialogVisible: false,
      isDeleteGroupDialogVisible: false,
      groupIdToDelete: '',
      isAddAnchorTypeDialogVisible: false,

      isExplodePanelVisible: false
    }
  },
  props: {
    showEngHeader: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Header,
    ViewTreePanel,
    Engine,
    CanvasMouseTip,
    TexturePanel,
    ParamsPanel,
    AddExtendParamsDialog,
    ElemSearchDialog,
    ViewportPanel,
    AddViewportDialog,
    AnnotationPanel,
    AnnotationToolBar,
    AddAnnotationDialog,
    AddAnnotationTypeDialog,
    AnnotationViewportImg,
    RoamingDialog,
    AnchorPanel,
    AddAnchorDialog,
    AddAnchorGroupDialog,
    AddAnchorTypeDialog,
    DeleteGroupDialog,
    ExplodePanel
  },
  computed: {
    sceneId() {
      return this.$route.query.sceneId
    }
  },
  mounted() {
    // eventBus.$on('changeScene', this.changeScene)
    this.initClientToken().then(() => {
      this.initSceneInfo()
    })

    this.$eventManage.on('engineCreated', this.onEngineCreated)
    this.$eventManage.on('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.on('themeChange', this.onUIThemeChange)
    this.$eventManage.on('customBtnClick', this.onCustomBtnClick)
    this.$eventManage.on('selElement', this.handleModelClick)
    this.$eventManage.on('selShpElement', this.handleVectorClick)

    this.$nextTick(() => {})
  },
  beforeDestroy() {
    this.$eventManage.off('engineCreated', this.onEngineCreated)
    this.$eventManage.off('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.off('themeChange', this.onUIThemeChange)
    this.$eventManage.off('customBtnClick', this.onCustomBtnClick)
    this.$eventManage.off('selElement', this.handleModelClick)
    this.$eventManage.off('selShpElement', this.handleVectorClick)
  },
  beforeRouteLeave(to, from, next) {
    this.delDom()
    next()
  },
  methods: {
    delDom() {
      this.deleteCustomBtn('Attribute')
      this.deleteCustomBtn('Catalog_Tree')
      this.deleteCustomBtn('Explode')

      let domRef = this.$refs.engine
      domRef.setEngineWorldCRS('')
      domRef.clearCamForcedLoc()

      this.copyCanvas()
    },

    changeScene(sceneId) {
      this.initClientToken().then(() => {
        this.initSceneInfo(sceneId)
      })
      this.onEngineCreated()
    },
    initClientToken() {
      return new Promise(resolve => {
        if (window.isClientAuthByConfig) {
          let params = {
            clientId: window.clientId,
            secretKey: window.secretKey,
            userId: window.userId
          }
          getClientTokenService(params).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                sessionStorage.setItem('token', response.token)
                sessionStorage.setItem('tokenId', response.tokenId)
                resolve()
              } else {
                this.$message.error(response.errMsg)
              }
            }
          })
        } else {
          resolve()
        }
      })
    },
    initSceneInfo(changeSceneId = null) {
      const sceneId = changeSceneId || this.$route.query.sceneId
      if (!sceneId) return
      getSceneById(sceneId).then(response => {
        if (response.isSuccess) {
          let sceneInfo = response.data
          this.sceneInfo = sceneInfo
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    onEngineCreated() {
      let timer = setInterval(() => {
        const domRef = this.$refs.engine
        if (!this.$route.query.sceneId) {
          clearInterval(timer)
          domRef.loadDataSets([])
          return
        }
        if (Object.keys(this.sceneInfo).length) {
          this.querySceneData().then(originSceneData => {
            this.originSceneData = originSceneData

            if (this.isNoValidData()) {
              // this.$message.warning('当前场景无有效数据')
              domRef.loadDataSets([])
              return
            }

            if (this.sceneInfo.coordinates) {
              domRef.setEngineWorldCRS(this.sceneInfo.coordinates)
            }

            let allDataSets = this.findAllDataSets()
            let dataSets = allDataSets.filter(el => el.viewStatus !== 2)
            this.getDataSetsResource(dataSets).then(dataSetsRes => {
              this.setSceneViewAngle().then(() => {
                domRef.incrementalLoadDataSets(dataSetsRes, 5)
              })
            })
          })

          clearInterval(timer)
        }
      }, 500)
    },
    onDataSetLoadFinish() {
      this.addEntities().then(() => {
        this.renderTexture()
        this.addCustomBtn()

        this.setUnitShpHole()
        this.setUnitLayerLevel()
        this.setUnitLODLevRange()

        this.addWaters()
        this.initExtrudeTextureList().then(() => {
          this.addExtrudes()
        })

        if (this.isChecked('Project.Single.SceneAnchorPoint.View')) {
          this.addAnchors()
        }
      })
    },
    addEntities() {
      return new Promise(resolve => {
        let allDataSets = this.findAllDataSets()
        let entityElems = allDataSets.filter(el =>
          elemDataSetType.includes(el.dataSetType)
        )

        entityElems = entityElems.filter(item => {
          let componentInfo = item.componentInfo
          if (componentInfo && componentInfo.isPublished) {
            return true
          } else {
            return false
          }
        })

        if (!entityElems.length) {
          resolve()
          return
        }

        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Entity.enterEditMode()
        let entityList = []
        entityElems.forEach(item => {
          let componentInfo = item.componentInfo
          let { dataSetId, hostFileId, elemId, location } = componentInfo
          let resId = dataSetId.replaceAll('-', '')

          let entity = new BlackHole3D.REEntityInfo()
          entity.dataSetId = resId
          entity.entityType = String(hostFileId)
          entity.elemId = elemId
          entity.scale = JSON.parse(location.scale)
          entity.rotate = JSON.parse(location.rotate)
          entity.offset = JSON.parse(location.translation)
          entity.dataSetCRS = location.dataSetCrs
          entityList.push(entity)
        })
        BlackHole3D.Entity.addEntities(entityList)
        BlackHole3D.Entity.exitEditMode()

        const AnimPlayModeEm = BlackHole3D.REEntityAnimPlayModeEm
        const AnimPlayStateEm = BlackHole3D.REEntityAnimPlayStateEm
        entityElems.forEach(item => {
          let componentInfo = item.componentInfo
          let { dataSetId, hostFileId, elemId, playMode } = componentInfo
          let resId = dataSetId.replaceAll('-', '')

          let animPlayInfo = new BlackHole3D.REEntityAnimPlayInfo()
          animPlayInfo.dataSetId = resId
          animPlayInfo.entityType = String(hostFileId)
          animPlayInfo.elemIdList = [elemId]
          animPlayInfo.animPlayMode = AnimPlayModeEm[playMode]
          if (componentInfo.enableAnimationPlay) {
            animPlayInfo.animPlayState = AnimPlayStateEm.PLAY
          } else {
            animPlayInfo.animPlayState = AnimPlayStateEm.PAUSE
          }
          BlackHole3D.Entity.setAnimPlayMode(animPlayInfo)
        })

        resolve()
      })
    },
    addCustomBtn() {
      let domRef = this.$refs.engine

      // 添加目录树按钮
      let treeLightImg = this.getImgPath('treeLight.png')
      let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
      let treeStateList = []
      treeStateList.push({ hintText: '目录树', texPath: treeLightImg })
      treeStateList.push({ hintText: '目录树', texPath: treeLightCheckImg })
      domRef.addCustomBtn('Catalog_Tree', treeStateList, 0)

      // 添加属性按钮
      let attrLightImg = this.getImgPath('attrLight.png')
      let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
      let attrStateList = []
      attrStateList.push({ hintText: '属性', texPath: attrLightImg })
      attrStateList.push({ hintText: '属性', texPath: attrLightCheckImg })
      domRef.addCustomBtn('Attribute', attrStateList, 0)

      // 添加爆炸按钮
      let explodeImg = this.getImgPath('explodeLight.png')
      let explodeLightCheckImg = this.getImgPath('explodeLightCheck.png')
      let explodeStateList = []
      explodeStateList.push({ hintText: '爆炸', texPath: explodeImg })
      // prettier-ignore
      explodeStateList.push({ hintText: "爆炸", texPath: explodeLightCheckImg });
      domRef.addCustomBtn('Explode', explodeStateList, 0)

      window.BlackHole3D.Graphics.setSysUIPanelVisible(true)
    },
    renderTexture() {
      let allDataSets = this.findAllDataSets()
      allDataSets = allDataSets.filter(
        el => el.viewStatus !== 2 && el.hasTexture
      )

      let promiseArray = []
      allDataSets.forEach(item => {
        let params = { dataSetId: item.dataSetId }
        let promise = getTextureList(params)
        promiseArray.push(promise)
      })

      Promise.all(promiseArray).then(response => {
        let textureList = []
        response.forEach(item => {
          if (item.isSuccess) {
            let appliedData = item.data.filter(
              el => el.isApplied && !el.removeStatus
            )
            textureList = [...appliedData, ...textureList]
          }
        })

        const BlackHole3D = window.BlackHole3D
        textureList.forEach(item => {
          let dataSetId = item.dataSetId
          dataSetId = dataSetId.replaceAll('-', '')

          let anim = new BlackHole3D.REElemUVAnim()
          anim.dataSetId = dataSetId
          anim.elemIdList = item.elements
          let scale = Number((1 / item.compressionRatio).toFixed(2))
          anim.scale = [scale, 1]
          let speed = item.direction > 0 ? item.flowRate : -item.flowRate
          anim.speed = [speed, 0]

          BlackHole3D.BIM.setElemUVAnimAttr(anim)
        })
      })
    },
    setUnitShpHole() {
      let allDataSets = this.findAllDataSets()
      allDataSets = allDataSets.filter(el => el.viewStatus !== 2)

      let terrainDataSets = allDataSets.filter(el => el.dataSetType === 22)
      let terrainDataArray = []
      terrainDataSets.forEach(item => {
        let isDigHole = item.isDigHole
        let dataSetId = item.dataSetId.replaceAll('-', '')

        let dataSetIds = window.BlackHole3D.Model.getAllDataSetId()
        if (dataSetIds.includes(dataSetId)) {
          let obj = { dataSetId, isDigHole }
          terrainDataArray.push(obj)
        }
      })
      let domRef = this.$refs.engine
      terrainDataArray.forEach(item => {
        domRef.setUnitShpHole(item.dataSetId, item.isDigHole)
      })
    },
    setUnitLayerLevel() {
      let allDataSets = this.findAllDataSets()
      allDataSets = allDataSets.filter(el => el.viewStatus !== 2)

      const terrainType = [10, 13, 21, 22]
      let terrainDataSets = allDataSets.filter(el =>
        terrainType.includes(el.dataSetType)
      )
      let terrainDataArray = []
      terrainDataSets.forEach(item => {
        let level = item.sortNum
        let dataSetId = item.dataSetId.replaceAll('-', '')

        let dataSetIds = window.BlackHole3D.Model.getAllDataSetId()
        if (dataSetIds.includes(dataSetId)) {
          let obj = { dataSetId, level }
          terrainDataArray.push(obj)
        }
      })

      let domRef = this.$refs.engine
      terrainDataArray.forEach(item => {
        domRef.setUnitLayerLevel(item.dataSetId, item.level)
      })
    },
    setUnitLODLevRange() {
      let allDataSets = this.findAllDataSets()
      allDataSets = allDataSets.filter(el => el.viewStatus !== 2)

      const terrainType = [21, 22]
      let terrainDataSets = allDataSets.filter(item => {
        if (terrainType.includes(item.dataSetType)) {
          // 将不贴地展示的CAD过滤掉
          if (item.dataSetType === 21) {
            if (item.isTouchDown) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        } else {
          return false
        }
      })

      let terrainDataArray = []
      terrainDataSets.map(item => {
        let systemLodConfig = item.systemLodConfig
        let maxLod = Number(systemLodConfig.lodNum) - 1
        let minLod = item.visibleDistance
        let dataSetId = item.dataSetId.replaceAll('-', '')

        let dataSetIds = window.BlackHole3D.Model.getAllDataSetId()
        if (dataSetIds.includes(dataSetId)) {
          let obj = { dataSetId, range: [minLod, maxLod] }
          terrainDataArray.push(obj)
        }
      })

      let domRef = this.$refs.engine
      terrainDataArray.forEach(item => {
        domRef.setUnitLODLevRange(item.dataSetId, item.range)
      })
    },
    addWaters() {
      let allLeafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let allWaters = allLeafNodes.filter(item => item.dataSetType == 23)

      let waterList = []
      const BlackHole3D = window.BlackHole3D
      allWaters.forEach(item => {
        let waterInfo = item.waterInfo
        let waterGeoJson = JSON.parse(waterInfo.geoJson)

        let rgnList = waterGeoJson.rgnList
        let rgnInfo = rgnList[0]
        let cornerRgnInfo = new BlackHole3D.RECornerRgnInfo()
        cornerRgnInfo.pointList = rgnInfo.pointList
        cornerRgnInfo.indexList = rgnInfo.indexList

        let waterRgnList = [cornerRgnInfo]
        let { red, green, blue, alpha } = waterGeoJson.waterClr
        let waterClr = new BlackHole3D.REColor(red, green, blue, alpha)
        let waterInstance = new BlackHole3D.REWaterInfo()
        waterInstance.waterName = waterInfo.id
        waterInstance.waterClr = waterClr
        waterInstance.blendDist = waterGeoJson.blendDist
        waterInstance.visible = waterGeoJson.visible
        waterInstance.expandDist = waterGeoJson.expandDist
        waterInstance.depthBias = waterGeoJson.depthBias
        waterInstance.visDist = waterGeoJson.visDist
        waterInstance.rgnList = waterRgnList

        waterList.push(waterInstance)
      })

      BlackHole3D.Water.setData(waterList)
    },
    addExtrudes() {
      let allLeafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let allExtrudes = allLeafNodes.filter(item => item.dataSetType == 24)

      let extrudeList = []
      let textureList = Store.extrudeTextureList
      const BlackHole3D = window.BlackHole3D
      allExtrudes.forEach(item => {
        let extrudeInfo = item.excavateInfo
        let extrudeGeoJson = JSON.parse(extrudeInfo.geoJson)

        let rgnList = extrudeGeoJson.rgnList
        let extrudeInstance = new BlackHole3D.REExtrudeInfo()
        extrudeInstance.extrudeId = extrudeInfo.id
        extrudeInstance.dataSetIdList = extrudeGeoJson.dataSetIdList
        extrudeInstance.rgnList = rgnList
        extrudeInstance.depthLimitRange = extrudeGeoJson.depthLimitRange
        extrudeInstance.type = extrudeGeoJson.type
        if (extrudeGeoJson.type === 2) {
          let find = textureList.find(
            el => el.textureGuid === extrudeInfo.textureFileDataId
          )
          extrudeInstance.texId = find.textureId
        }

        extrudeList.push(extrudeInstance)
      })

      BlackHole3D.Extrude.setData(extrudeList)
    },
    async addAnchors() {
      if (!this.sceneInfo.enableAnchorPointShow) return

      const anchorList = await this.getAnchorList()

      const BlackHole3D = window.BlackHole3D

      let normalAnchorList = []
      let animAnchorList = []
      anchorList.forEach(item => {
        let anchorList = item.anchorPointList
        anchorList.forEach(anchor => {
          let visibleDistanceUnit = anchor.visibleDistanceUnit
          let scalingThresholdUnit = anchor.scalingThresholdUnit
          // prettier-ignore
          let selfAutoScaleDist = scalingThresholdUnit === "Kilometer" ? anchor.scalingThreshold * 1000 : anchor.scalingThreshold;
          // prettier-ignore
          let selfVisDist = visibleDistanceUnit === "Kilometer" ? anchor.visibleDistance * 1000 : anchor.visibleDistance;

          let anchorInfo = {
            groupName: item.groupId,
            ancName: anchor.sceneAnchorPointId,
            pos: JSON.parse(anchor.position),
            textInfo: anchor.name,
            picWidth: 32,
            picHeight: 32,
            selfAutoScaleDist: selfAutoScaleDist,
            selfVisDist: selfVisDist,
            texBias: [0, 1],
            texFocus: [16, 0],
            textClr: new BlackHole3D.REColor(255, 255, 255, 255),
            useLod: item.aggregationStatus ? true : false
          }

          if (anchor.displayForm === 0) {
            let timestamp = new Date().getTime()
            let picPath = `${window.imageBaseUrl}/${anchor.iconUrl}?timestamp=${timestamp}`
            anchorInfo.ancSize = 32
            anchorInfo.picPath = picPath
            normalAnchorList.push(anchorInfo)
          } else {
            anchorInfo.picPath = animAnchorPicPath
            anchorInfo.picNum = 6
            anchorInfo.playFrame = 2
            animAnchorList.push(anchorInfo)
          }
        })
      })

      if (normalAnchorList.length) {
        BlackHole3D.Anchor.addAnc(normalAnchorList)
      }

      if (animAnchorList.length) {
        BlackHole3D.Anchor.addAnimAnc(animAnchorList)
      }

      let mergeGroup = anchorList.filter(el => el.aggregationStatus)
      let mergeAnchorGroupList = []

      const mergestyle = new BlackHole3D.REAncInfo()
      mergestyle.picPath = mergePicPath
      mergestyle.picWidth = 32
      mergestyle.picHeight = 32
      mergestyle.textBias = [1, 0]
      mergestyle.fontName = 'RealBIMFont001'
      mergestyle.textClr = new BlackHole3D.REColor(255, 255, 255, 255)

      mergeGroup.forEach(item => {
        let ancLODInfo = new BlackHole3D.REAncLODInfo()
        ancLODInfo.groupName = item.groupId
        ancLODInfo.lodLevel = 10
        ancLODInfo.useCustomBV = false
        ancLODInfo.customBV = []
        ancLODInfo.lodMergePxl = 300.0
        ancLODInfo.lodMergeCap = 2
        ancLODInfo.mergeStyle = mergestyle
        mergeAnchorGroupList.push(ancLODInfo)
      })

      mergeAnchorGroupList.forEach(item => {
        BlackHole3D.Anchor.setAncLODInfo(item)
      })
    },
    async getAnchorList() {
      let sceneId = this.$route.query.sceneId
      const response = await getSceneAnchorListService(sceneId)

      if (response.isSuccess) {
        let anchorList = response.data
        anchorList.forEach(item => {
          item.originGroupName = item.groupName
          let anchorPointList = item.anchorPointList
          anchorPointList.forEach(anchorInfo => {
            anchorInfo.groupName = item.groupName
          })
        })
        return anchorList
      } else {
        this.$message.error(response.errMsg)
        return []
      }
    },
    closeViewTreePanel() {
      this.viewTreePanelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Catalog_Tree', 0)
    },
    openTexturePanel(data) {
      if (
        this.isAnnotationToolBarVisible ||
        this.$refs.anchorPanel?.isDisabledBtn
      ) {
        this.$refs.anchorPanel?.isDisabledBtn &&
          this.$message.warning('正在添加锚点中，请先关闭')
        this.isAnnotationToolBarVisible &&
          this.$message.warning('正在添加批注中，请先关闭')
        return
      }
      this.closeAllMethod()

      this.currSelectDataSet = data
      this.texturePanelVisible = true

      // this.$nextTick(() => {
      //   const domRef = this.$refs.paramsPanel
      //   setDialogRef(domRef, this.closeParamsPanel)
      // })
    },
    closeTexturePanel() {
      this.currSelectDataSet = {}
      this.texturePanelVisible = false
    },
    closeParamsPanel() {
      if (!this.isParamsPanelVisible) return

      this.isParamsPanelVisible = false
      this.currElemInfo = {}
      window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
    },
    setCurrentKey(nodeId) {
      let domRef = this.$refs.viewTreePanel
      if (domRef) {
        domRef.setCurrentKey(nodeId)
      }
    },
    closeExplodePanel() {
      this.isExplodePanelVisible = false
      window.BlackHole3D.Graphics.setBtnActiveState('Explode', 0)
    },
    openAddextendParamsDialog(fileName, elemName) {
      this.currElemInfo.fileName = fileName
      this.currElemInfo.elemName = elemName
      this.isAddExtendParamsDialogVisible = true
    },
    closeAddextendParamsDialog() {
      let domRef = this.$refs.paramsPanel
      if (domRef) {
        domRef.refreshParams()
      }

      this.currElemInfo.elemName = ''
      this.isAddExtendParamsDialogVisible = false
    },
    closeRoamingVisible(flag = false) {
      if (!this.RoamingVisible) return

      if (flag !== true) {
        this.activeToolBar = ''
      }
      this.RoamingVisible = false
    },

    // 关闭所有弹窗
    closeAllMethod() {
      this.closeElemSearchDialog()
      this.closeParamsPanel()
      this.closeViewportPanel()
      this.closeRoamingVisible()
      this.closeAnnotationPanel()
      this.closeAnchorPanel()
    },
    openElemSearchDialog(toolBar) {
      if (
        this.isAnnotationToolBarVisible ||
        this.$refs.anchorPanel?.isDisabledBtn
      ) {
        this.$refs.anchorPanel?.isDisabledBtn &&
          this.$message.warning('正在添加锚点中，请先关闭')
        this.isAnnotationToolBarVisible &&
          this.$message.warning('正在添加批注中，请先关闭')
        return
      }
      this.closeAllMethod()
      this.activeToolBar = toolBar
      let leafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      // prettier-ignore
      let bimNodes = leafNodes.filter((el) => el.dataSetType === 0 && el.viewStatus !== 2);
      if (!bimNodes.length) {
        this.$message.warning('当前场景无可检索的BIM数据，请先添加BIM数据！')
        return
      }
      this.isElemSearchDialogVisible = true
      // this.$nextTick(() => {
      //   setDialogRef('openElemSearchDialog', this.closeElemSearchDialog)
      // })
    },
    closeElemSearchDialog() {
      this.isElemSearchDialogVisible = false
    },
    openViewPortPanel(toolBar) {
      if (
        this.isAnnotationToolBarVisible ||
        this.$refs.anchorPanel?.isDisabledBtn
      ) {
        this.$refs.anchorPanel?.isDisabledBtn &&
          this.$message.warning('正在添加锚点中，请先关闭')
        this.isAnnotationToolBarVisible &&
          this.$message.warning('正在添加批注中，请先关闭')
        return
      }
      this.closeAllMethod()
      this.activeToolBar = toolBar
      this.isViewportPanelVisible = true
      // this.$nextTick(() => {
      //   setDialogRef('openViewPortPanel', this.closeViewportPanel)
      // })
    },
    openRoaming(toolBar) {
      if (
        this.isAnnotationToolBarVisible ||
        this.$refs.anchorPanel?.isDisabledBtn
      ) {
        this.$refs.anchorPanel?.isDisabledBtn &&
          this.$message.warning('正在添加锚点中，请先关闭')
        this.isAnnotationToolBarVisible &&
          this.$message.warning('正在添加批注中，请先关闭')
        return
      }
      this.closeAllMethod()
      this.activeToolBar = toolBar
      this.RoamingVisible = true
      // this.$nextTick(() => {
      //   setDialogRef('openRoaming', this.closeRoamingVisible)
      // })
    },
    refreshViewportList() {
      return new Promise(resolve => {
        let domRef = this.$refs.viewportPanel
        if (domRef) {
          domRef.refreshViewportList().then(() => {
            resolve()
          })
        }
      })
    },
    closeViewportPanel(flag = false) {
      if (!this.isViewportPanelVisible) return

      if (!flag) {
        this.activeToolBar = ''
      }
      this.isViewportPanelVisible = false
      // const domRef = this.$refs.viewportPanel
      // closeOtherDialog(domRef)
    },
    openAddViewportDialog(viewportInfo) {
      this.isAddViewportDialogVisible = true
      if (viewportInfo) {
        this.viewportInfo = viewportInfo
      }
    },
    closeAddViewportDialog() {
      this.isAddViewportDialogVisible = false
      this.viewportInfo = null
    },
    openAnnotationPanel(toolBar) {
      if (
        this.isAnnotationToolBarVisible ||
        this.$refs.anchorPanel?.isDisabledBtn
      ) {
        this.$refs.anchorPanel?.isDisabledBtn &&
          this.$message.warning('正在添加锚点中，请先关闭')
        this.isAnnotationToolBarVisible &&
          this.$message.warning('正在添加批注中，请先关闭')
        return
      }
      this.closeAllMethod()
      this.activeToolBar = toolBar
      this.isAnnotationPanelVisible = true
      // this.$nextTick(() => {
      //   setDialogRef('openAnnotationPanel', this.closeAnnotationPanel)
      // })
    },
    closeAnnotationPanel(flag = false) {
      if (this.isAnnotationToolBarVisible) {
        this.$message.warning('请先关闭批注编辑工具')
        // this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {})
        // this.isAnnotationPanelVisible = false;
        return
      }
      if (!flag) {
        this.activeToolBar = ''
      }
      this.isAnnotationPanelVisible = false
    },
    openAnnotationToolBar() {
      this.isAnnotationToolBarVisible = true
    },
    closeAnnotationToolBar() {
      this.isAnnotationToolBarVisible = false
    },
    openAddAnnotationDialog(annotationInfo) {
      this.isAddAnnotationDialogVisible = true
      if (annotationInfo) {
        this.annotationInfo = annotationInfo
      }
    },
    openAnnotationViewport(viewportImg) {
      this.viewportImg = viewportImg
      this.isAnnotationViewportImgVisible = true
    },
    closeAnnotationViewport() {
      this.isAnnotationViewportImgVisible = false
      this.viewportImg = ''
    },
    addViewport() {
      let domRef = this.$refs.annotationToolBar
      if (domRef) {
        domRef.addViewport()
      }
    },
    modifyViewport() {
      let domRef = this.$refs.annotationToolBar
      if (domRef) {
        domRef.modifyViewport()
      }
    },
    refreshAnnotationList() {
      return new Promise(resolve => {
        let domRef = this.$refs.annotationPanel
        if (domRef) {
          domRef.refreshAnnotationList().then(() => {
            resolve()
          })
        }
      })
    },
    closeAddAnnotationDialog() {
      this.isAddAnnotationDialogVisible = false
      this.annotationInfo = {}
    },
    openAnnotatioTypeDialog() {
      this.isAddAnnotatioTypeDialogVisible = true
    },
    refreshAnnotationTypeList(annotationPointTypeId) {
      let addAnnotationDomRef = this.$refs.addAnnotationDialog
      if (addAnnotationDomRef) {
        addAnnotationDomRef.initAnnotationTypeList(annotationPointTypeId)
      }
    },
    closeAnnotatioTypeDialog() {
      this.isAddAnnotatioTypeDialogVisible = false
    },
    openAnchorPanel(toolBar) {
      if (
        this.isAnnotationToolBarVisible ||
        this.$refs.anchorPanel?.isDisabledBtn
      ) {
        this.$refs.anchorPanel?.isDisabledBtn &&
          this.$message.warning('正在添加锚点中，请先关闭')
        this.isAnnotationToolBarVisible &&
          this.$message.warning('正在添加批注中，请先关闭')
        return
      }
      this.closeAllMethod()
      this.activeToolBar = toolBar
      this.isAnchorPanelVisible = true
      // this.$nextTick(() => {
      //   setDialogRef('openAnchorPanel', this.closeAnchorPanel)
      // })
    },
    openAnchorDialog(anchorInfo) {
      this.isAddAnchorDialogVisible = true
      if (anchorInfo) {
        this.anchorInfo = anchorInfo
      }
    },
    closeAddAnchorDialog() {
      let domRef = this.$refs.anchorPanel
      if (domRef) {
        domRef.enableBtn()
      }

      this.isAddAnchorDialogVisible = false
      this.anchorInfo = null
    },
    openAnchorGroupDialog() {
      this.isAddAnchorGroupDialogVisible = true
    },
    closeAnchorGroupDialog() {
      this.isAddAnchorGroupDialogVisible = false
    },
    openAnchorTypeDialog() {
      this.isAddAnchorTypeDialogVisible = true
    },
    closeAnchorTypeDialog() {
      this.isAddAnchorTypeDialogVisible = false
    },
    openDeleteGroupDialog(groupIdToDelete) {
      this.isDeleteGroupDialogVisible = true
      this.groupIdToDelete = groupIdToDelete
    },
    closeDeleteGroupDialog() {
      this.groupIdToDelete = ''
      this.isDeleteGroupDialogVisible = false
    },
    refreshAnchorList() {
      return new Promise(resolve => {
        let domRef = this.$refs.anchorPanel
        if (domRef) {
          domRef.refreshAnchorList().then(() => {
            resolve()
          })
        }
      })
    },
    refreshAnchorGroupList(groupId) {
      return new Promise(resolve => {
        let domRef = this.$refs.anchorPanel
        if (domRef) {
          domRef.refreshAnchorList().then(() => {
            resolve()
          })
        }

        let addAnchorDomRef = this.$refs.addAnchorDialog
        if (addAnchorDomRef) {
          addAnchorDomRef.initGroupList(groupId)
        }
      })
    },
    refreshAnchorTypeList(anchorPointTypeId) {
      let addAnchorDomRef = this.$refs.addAnchorDialog
      if (addAnchorDomRef) {
        addAnchorDomRef.initAnchorTypeList(anchorPointTypeId)
      }
    },
    reRnderAnchor(isMigrationGroup, originGroupId, targetGroupId) {
      let domRef = this.$refs.anchorPanel
      if (domRef) {
        domRef.reRnderAnchor(isMigrationGroup, originGroupId, targetGroupId)
      }
    },
    closeAnchorPanel(flag = false) {
      if (this.isAddAnchorDialogVisible) {
        this.$confirm('正在添加锚点，您确定要退出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isAnchorPanelVisible = false
          this.isAddAnchorDialogVisible = false
          this.anchorInfo = null
        })
        return
      }

      if (!flag) {
        this.activeToolBar = ''
      }
      // const domRef = this.$refs.anchorPanel
      // console.log(domRef,'domRef');
      if (!this.sceneInfo.enableAnchorPointShow) {
        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Anchor.delAllAnc()
      }
      // domRef&&domRef.closePanel()
      this.isAnchorPanelVisible = false
      this.isAddAnchorDialogVisible = false
      this.anchorInfo = null
    },
    focusDataSets(dataSets) {
      let domRef = this.$refs.engine
      domRef.focusDataSets(dataSets, true)
    },
    focusElems(dataSets) {
      let domRef = this.$refs.engine
      domRef.focusElems(dataSets, true, true)
    },
    showDataSets(dataSets) {
      let domRef = this.$refs.engine
      domRef.showDataSets(dataSets)
    },
    hideDataSets(dataSets) {
      let domRef = this.$refs.engine
      domRef.hideDataSets(dataSets)
    },
    showElement(dataSetId, childNodeIds) {
      let domRef = this.$refs.engine
      domRef.showElement(dataSetId, childNodeIds)
    },
    hiddenElement(dataSetId, childNodeIds) {
      let domRef = this.$refs.engine
      domRef.hiddenElement(dataSetId, childNodeIds)
    },
    highLightWaters(waterIds) {
      let domRef = this.$refs.engine
      domRef.highLightWaters(waterIds)
    },
    showWaters(waterIds) {
      let domRef = this.$refs.engine
      domRef.showWaters(waterIds)
    },
    hideWaters(waterIds) {
      let domRef = this.$refs.engine
      domRef.hideWaters(waterIds)
    },
    highLightExtrudes(extrudeIds) {
      let domRef = this.$refs.engine
      domRef.highLightExtrudes(extrudeIds)
    },
    showExtrudes(extrudeIds) {
      let domRef = this.$refs.engine
      domRef.showExtrudes(extrudeIds)
    },
    hideExtrudes(extrudeIds) {
      let domRef = this.$refs.engine
      domRef.hideExtrudes(extrudeIds)
    },
    onUIThemeChange(eventInfo) {
      let themeName = eventInfo.themeName

      let Graphics = window.BlackHole3D.Graphics
      if (themeName.includes('Light')) {
        let treeLightImg = this.getImgPath('treeLight.png')
        let treeLightCheckImg = this.getImgPath('treeLightCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeLightImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 0)

        let attrLightImg = this.getImgPath('attrLight.png')
        let attrLightCheckImg = this.getImgPath('attrLightCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrLightImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 0)

        let explodeLightImg = this.getImgPath('explodeLight.png')
        let explodeLightCheckImg = this.getImgPath('explodeLightCheck.png')
        Graphics.setBtnStatePicPath('Explode', 0, explodeLightImg)
        Graphics.setBtnStatePicPath('Explode', 1, explodeLightCheckImg)
        Graphics.setSysPanelBtnClrStyle('Explode', 0)
      }

      if (themeName.includes('Dark')) {
        let treeDarkImg = this.getImgPath('treeDark.png')
        let treeDarkCheckImg = this.getImgPath('treeDarkCheck.png')
        Graphics.setBtnStatePicPath('Catalog_Tree', 0, treeDarkImg)
        Graphics.setBtnStatePicPath('Catalog_Tree', 1, treeDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Catalog_Tree', 1)

        let attrDarkImg = this.getImgPath('attrDark.png')
        let attrDarkCheckImg = this.getImgPath('attrDarkCheck.png')
        Graphics.setBtnStatePicPath('Attribute', 0, attrDarkImg)
        Graphics.setBtnStatePicPath('Attribute', 1, attrDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Attribute', 1)

        let explodeDarkImg = this.getImgPath('explodeDark.png')
        let explodeDarkCheckImg = this.getImgPath('explodeDarkCheck.png')
        Graphics.setBtnStatePicPath('Explode', 0, explodeDarkImg)
        Graphics.setBtnStatePicPath('Explode', 1, explodeDarkCheckImg)
        Graphics.setSysPanelBtnClrStyle('Explode', 1)
      }
    },

    onCustomBtnClick(eventInfo) {
      let btnName = eventInfo.btnName
      let Graphics = window.BlackHole3D.Graphics
      let btnStatus = Graphics.getBtnActiveState(btnName)
      if (btnName.includes('Catalog_Tree')) {
        if (btnStatus === 1) {
          this.viewTreePanelVisible = true
        } else {
          this.viewTreePanelVisible = false
        }
      }

      if (btnName.includes('Attribute')) {
        if (btnStatus === 1) {
          if (
            this.isAnnotationToolBarVisible ||
            this.$refs.anchorPanel?.isDisabledBtn
          ) {
            this.$refs.anchorPanel?.isDisabledBtn &&
              this.$message.warning('正在添加锚点中，请先关闭')
            this.isAnnotationToolBarVisible &&
              this.$message.warning('正在添加批注中，请先关闭')
            window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 0)
            return
          }
          // 解决因调用closeAllMethod方法，出现数据丢失的问题
          let currElemInfo = {}
          if (Object.keys(this.currElemInfo).length) {
            currElemInfo = this.currElemInfo
          }
          this.closeAllMethod()
          this.closeTexturePanel()
          this.isParamsPanelVisible = true
          // 解决因调用closeAllMethod方法，出现数据丢失的问题
          this.currElemInfo = currElemInfo
          // 解决因调用closeAllMethod方法，出现状态丢失的问题
          window.BlackHole3D.Graphics.setBtnActiveState('Attribute', 1)
          window.BlackHole3D.Graphics.setBtnActiveState('Texture', 0)
        } else {
          this.isParamsPanelVisible = false
        }
      }

      if (btnName.includes('Explode')) {
        if (btnStatus === 1) {
          this.isExplodePanelVisible = true
        } else {
          this.isExplodePanelVisible = false
        }
      }
    },
    handleModelClick(eventInfo) {
      let elemInfo = eventInfo.elemInfo
      if (elemInfo.elemType !== 'BIMElem') {
        this.currElemInfo = {}
        return
      }

      let resId = elemInfo.dataSetId
      let leafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let findNode
      // 先从BIM模型节点中查找
      let bimNodes = leafNodes.filter(el => el.dataSetType === 0)
      findNode = bimNodes.find(item => {
        let dataSetId = item.dataSetId
        dataSetId = dataSetId.replaceAll('-', '')
        if (resId === dataSetId) return true
      })

      if (!findNode) {
        // 如果BIM模型节点中未找到，再从单构件节点中查找
        let entityNodes = leafNodes.filter(el => el.dataSetType === 19)
        findNode = entityNodes.find(item => {
          let elemId = item.componentInfo.elemId
          if (elemId === elemInfo.elemId) return true
        })
      }
      if (!findNode) return

      let currElemInfo = {
        elemType: elemInfo.elemType,
        dataSetType: findNode.dataSetType
      }

      if (findNode.dataSetType === 0) {
        currElemInfo.elemId = elemInfo.elemId
        currElemInfo.dataSetId = findNode.dataSetId
        const isRvtGroupMode = this.$refs.viewTreePanel?.isRvtGroupMode
        currElemInfo.isRvtGroupMode = isRvtGroupMode

        // 如果以分组组织目录树，点击构件时，需要高亮构件所在分组的所有构件
        if (isRvtGroupMode) {
          this.highLightGroupElems(findNode.dataSetId, elemInfo.elemId)
        }
      } else {
        let entityInfo = findNode.componentInfo
        currElemInfo.elemId = entityInfo.id
        currElemInfo.dataSetId = entityInfo.dataSetId
        currElemInfo.hostFileId = entityInfo.hostFileId
      }

      this.currElemInfo = currElemInfo
    },
    handleVectorClick(eventInfo) {
      let vectorInfo = eventInfo.shpElemInfo
      if (vectorInfo.elemType !== 'ShapeElem') {
        this.currElemInfo = {}
        return
      }

      let resId = vectorInfo.dataSetId
      let leafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let findNode = leafNodes.find(item => {
        let dataSetId = item.dataSetId
        dataSetId = dataSetId.replaceAll('-', '')
        if (resId === dataSetId) return true
      })
      if (!findNode) return

      let currElemInfo = {
        dataSetId: findNode.dataSetId,
        elemType: vectorInfo.elemType,
        elemId: vectorInfo.elemId,
        dataSetType: findNode.dataSetType
      }

      this.currElemInfo = currElemInfo
    },
    async highLightGroupElems(dataSetId, elemId) {
      const getGroupIdparams = { dataSetId, elemIntId: elemId }
      const groupIdResponse = await getRvtGroupByElemIdService(getGroupIdparams)
      if (groupIdResponse.isSuccess) {
        const groupInfo = groupIdResponse.data
        if (!groupInfo) return

        const groupIntId = groupInfo?.groupIntId
        const hostFileId = groupInfo?.hostFileId
        const params = {
          dataSetId,
          hostFileId: String(hostFileId),
          childNodeId: [groupIntId]
        }
        const response = await getBimElemIdsByGroupService(params)
        if (response.isSuccess) {
          const data = response.data
          const resId = dataSetId.replaceAll('-', '')
          const elemIds = data.childNodeIds.length
            ? data.childNodeIds
            : [elemId]
          highLightElems(resId, elemIds, false)
        } else {
          this.$message.error(response.errMsg)
        }
      } else {
        this.$message.error(groupIdResponse.errMsg)
      }
    },
    isNoValidData() {
      let allDataSets = this.findAllDataSets()
      let validDataSets = allDataSets.filter(el => el.viewStatus !== 2)
      if (validDataSets.length) {
        return false
      } else {
        return true
      }
    },
    setSceneViewAngle() {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        let params = {
          definedType: 2,
          resourceId: sceneId
        }
        getViewAngleService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let visualAngle = data.visualAngle
            if (visualAngle && visualAngle !== 'DefaultVisualAngle') {
              let camLoc = JSON.parse(visualAngle)
              let domRef = this.$refs.engine
              domRef.setViewAngle(camLoc)
            }
          } else {
            this.$message.error(response.errMsg)
          }
          resolve()
        })
      })
    },
    getDataSetsResource(dataSets) {
      return new Promise(resolve => {
        this.queryDataSetRes(dataSets).then(dataSetsRes => {
          let { dataSetPosition } = this.sceneInfo
          dataSetsRes.forEach(item => {
            if (item.dataSetType !== 19) {
              let find = dataSetPosition.find(
                el => el.dataSetId === item.dataSetId
              )
              if (find) {
                item.rotate = find.rotate
                item.scale = find.scale
                item.translation = find.translation
              }
            }

            if (item.dataSetType === 21 || item.dataSetType === 22) {
              let find = dataSets.find(el => el.dataSetId === item.dataSetId)
              item.isTouchDown = find.isTouchDown
            }
          })
          resolve(dataSetsRes)
        })
      })
    },
    queryDataSetRes(dataSets) {
      return new Promise(resolve => {
        let dataSetList = dataSets.filter(
          el => !elemDataSetType.includes(el.dataSetType)
        )
        let dataSetIds = dataSetList.map(el => el.dataSetId)

        let entityElems = dataSets.filter(item => {
          let componentInfo = item.componentInfo
          if (componentInfo && componentInfo.isPublished) {
            return true
          } else {
            return false
          }
        })
        if (entityElems.length) {
          dataSetIds.push(this.sceneInfo.componentTreeId)
        }
        getDataSetResService({ dataSetIds }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let dataSetRes = data
            resolve(dataSetRes)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    querySceneData() {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        if (sceneId) {
          let params = { sceneId, isPublished: true }
          getSingleSceneTreeById(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let sceneData = this.formatSceneData(data)
              resolve(sceneData)
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          // 防止进入场景后立即返回，导致调用接口报错
          resolve([])
        }
      })
    },
    formatSceneData(data) {
      if (!data) return []
      let sceneData = data
      let rootFolders = this.findAllNodeByLevel(sceneData, 3)
      rootFolders.forEach(item => {
        if (item.dataSetType === 0) {
          item['sceneNodeName'] = 'BIM'
          item['nodeName'] = 'BIM'
          item['levelPathName'] = 'BIM'
        }
        if (item.dataSetType === 10) {
          item['sceneNodeName'] = 'WMTS'
          item['nodeName'] = 'WMTS'
          item['levelPathName'] = 'WMTS'
        }
      })

      let folders = this.findAllNodeByLevel(sceneData, 1)
      let allFolders = [...rootFolders, ...folders]
      allFolders.forEach(item => {
        let rootNodeId = item.levelCode.split('/')[0]
        let find = rootFolders.find(el => el.sceneNodeId === rootNodeId)
        item.dataSetType = find.dataSetType
        item.srcDataSetType = find.srcDataSetType
        item['nodeName'] = item.sceneNodeName
        item['nodeId'] = item.sceneNodeId
      })

      let allDatasets = this.findAllNodeByLevel(sceneData, 2)
      let { componentPosition } = this.sceneInfo
      allDatasets.forEach(item => {
        if (item.dataSetType === 0) {
          item['levelPathName'] = item.levelPathName.replace('模型/', 'BIM/')
          item['levelPathName'] = item.levelPathName.replace('模型/', 'BIM/')
        }
        if (item.dataSetType === 10) {
          item['levelPathName'] = item.levelPathName.replace('wmts/', 'WMTS/')
        }

        item['customNodeType'] = 'dataSet'
        item['nodeId'] = item.sceneNodeId
        let findLastIndex = item.sceneNodeName.lastIndexOf('.')
        if (findLastIndex !== -1) {
          item['nodeName'] = item.sceneNodeName.substring(0, findLastIndex)
          item['sceneNodeName'] = item.nodeName
        } else {
          item['nodeName'] = item.sceneNodeName
        }

        if (item.viewStatus === 2) {
          item['disabled'] = true
        }

        if (item.dataSetType === 0 && item.viewStatus !== 2) {
          item.subNodes.push({ nodeName: '' })
        }

        if (elemDataSetType.includes(item.dataSetType)) {
          let componentInfo = item.componentInfo
          componentInfo.id = componentInfo.treeNodeId
          let find = componentPosition.find(el => el.id === componentInfo.id)
          if (find) {
            componentInfo.location = {
              rotate: find.rotate,
              scale: find.scale,
              translation: find.translation
            }
          }
          let { hostFileId, instanceIndex, isPublished } = componentInfo
          if (isPublished) {
            componentInfo.dataSetId = this.sceneInfo.componentTreeId
            componentInfo.elemId = Number(`${hostFileId}${instanceIndex}`)
          }
        }

        // 水面类型，将waterId提升一级，方便调用
        if (item.dataSetType === 23) {
          let waterInfo = item.waterInfo
          item.waterId = waterInfo.id
        }

        // 开挖类型，将extrudeId提升一级，方便调用
        if (item.dataSetType === 24) {
          let extrudeInfo = item.excavateInfo
          item.extrudeId = extrudeInfo.id
        }
      })
      // 隐藏没有数据的根节点
      sceneData = sceneData.filter(el => el.subNodes.length)

      return sceneData
    },
    findAllNodeByLevel(data, level) {
      const array = []

      const traverse = item => {
        if (item.nodeType === level) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    },
    findAllDataSets() {
      // 在场景中需要依赖资源包才能展示的数据类型
      const dependentResourceTypes = [0, 10, 11, 13, 15, 16, 19, 21, 22]

      let allLeafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let dataSets = allLeafNodes.filter(item => {
        // prettier-ignore
        let bool = item.viewStatus !== 2 && dependentResourceTypes.includes(item.dataSetType);
        return bool
      })
      return dataSets
    },
    initExtrudeTextureList() {
      return new Promise(resolve => {
        let textureList = Store.extrudeTextureList
        if (textureList.length) {
          resolve()
          return
        }

        getExtrudeTexturesService().then(response => {
          if (response.isSuccess) {
            let data = response.data
            let intrinsicTextures = data.intrinsicTextures

            if (intrinsicTextures && intrinsicTextures.length) {
              const Extrude = window.BlackHole3D.Extrude
              textureList = intrinsicTextures.map(item => {
                let picPath = ''
                let tokenId = getTokenId()
                let timestamp = new Date().getTime()
                if (window.downloadUrl.includes('http')) {
                  picPath = `${window.downloadUrl}/${item.fileDataId}?token=${tokenId}&timestamp=${timestamp}`
                } else {
                  picPath = `${window.serverUrl}/${window.downloadUrl}/${item.fileDataId}?token=${tokenId}&timestamp=${timestamp}`
                }
                let size = [5.0, 5.0]
                let textureId = Extrude.addExtrudeFaceTex(picPath, size)

                let obj = {
                  textureId,
                  textureGuid: item.TextureImageId,
                  texturePicPath: picPath
                }
                return obj
              })
            }

            Store.extrudeTextureList = textureList
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getImgPath(iconName) {
      let { origin, pathname } = window.location
      let iconPath = `${origin}${pathname.split('/index.html')[0]}`
      return `${iconPath}/engineIcon/${iconName}`
    },
    deleteCustomBtn(uiID) {
      window.BlackHole3D.Graphics.delWidget(uiID)
    },
    copyCanvas() {
      const canvasBox = document.getElementById('engineCanvas')
      if (canvasBox) {
        const canvasContainer = document.getElementById('canvas-container')
        canvasContainer.append(canvasBox)
      }
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  },
  watch: {
    sceneId(newVal, oldVal) {
      if (newVal) {
        this.closeViewTreePanel()
        this.initClientToken().then(() => {
          this.initSceneInfo()
        })
        this.onEngineCreated()
        this.$refs.engine.canvasVisible = false
        this.$refs.engine.isLoadingVisible = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.scene-view-box {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100% !important;
  overflow: hidden;

  .engine-box {
    position: relative;
    height: calc(100% - 64px);
  }
}
</style>
